import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useActions } from '../../providers/actions-provider/actions.context';
import { useStore } from '../../../store';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';
import { USER_ID } from '../../../store/modules/user/user.constants';

interface IInitialValues {
  groupType_id: number | null,
  name: string,
  icon: null | string,
  tenant:string
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useGetCreateGroupTypeData = () => {
  const { facilityActions, userActions } = useActions();
  const { groupTypes, currentUser } = useStore();
  const lastGroupType = Object.values(groupTypes.data).pop();
  const { id } = useParams<{id:string}>();
  const isEdit = Boolean(id);
  const currentGroupType = isEdit && groupTypes.data[id];

  const localStorageService = useLocalStorage();
  const userID: number | null = localStorageService.get(USER_ID);
  useEffect(() => {
    if (userID) {
      userActions.getCurrentUser(+userID);
    }
  }, []);

  return useMemo(() => ({
    initialValues: {
      name: currentGroupType ? currentGroupType.name : '',
      icon: currentGroupType ? currentGroupType.icon : null,
      groupType_id: lastGroupType
        ? lastGroupType.id : null,
      tenant: currentUser.data.tenant,
    },
    loading: groupTypes.loading,
    isEdit,
    title: currentGroupType && isEdit ? currentGroupType.name : 'Create Group Type',
    onDelete: () => {
      facilityActions.deleteGroupType(+id);
    },
    onSubmit: (values: IInitialValues) => {
      if (isEdit) {
        facilityActions.editGroupType({
          ...values,
          id,
        });
        facilityActions.getGroupTypes();
      } else {
        facilityActions.createGroupType({
          ...values,
        });
        facilityActions.getGroupTypes();
      }
    },

  }), [groupTypes, lastGroupType, id]);
};

export default useGetCreateGroupTypeData;
